/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { officeControllerCreate } from '../fn/office/office-controller-create';
import { OfficeControllerCreate$Params } from '../fn/office/office-controller-create';
import { officeControllerDelete } from '../fn/office/office-controller-delete';
import { OfficeControllerDelete$Params } from '../fn/office/office-controller-delete';
import { officeControllerFindAll } from '../fn/office/office-controller-find-all';
import { OfficeControllerFindAll$Params } from '../fn/office/office-controller-find-all';
import { officeControllerFindAllDropdown } from '../fn/office/office-controller-find-all-dropdown';
import { OfficeControllerFindAllDropdown$Params } from '../fn/office/office-controller-find-all-dropdown';
import { officeControllerFindOne } from '../fn/office/office-controller-find-one';
import { OfficeControllerFindOne$Params } from '../fn/office/office-controller-find-one';
import { officeControllerGetIncidentsList } from '../fn/office/office-controller-get-incidents-list';
import { OfficeControllerGetIncidentsList$Params } from '../fn/office/office-controller-get-incidents-list';
import { officeControllerRestore } from '../fn/office/office-controller-restore';
import { OfficeControllerRestore$Params } from '../fn/office/office-controller-restore';
import { officeControllerUpdate } from '../fn/office/office-controller-update';
import { OfficeControllerUpdate$Params } from '../fn/office/office-controller-update';
import { OfficeDto } from '../models/office-dto';
import { OfficeListItemDto } from '../models/office-list-item-dto';
import { OfficeNameDto } from '../models/office-name-dto';
import { PaginatedDto } from '../models/paginated-dto';

@Injectable({ providedIn: 'root' })
export class OfficeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `officeControllerFindAll()` */
  static readonly OfficeControllerFindAllPath = '/api/office';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerFindAll$Response(params: OfficeControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDto & {
'items'?: Array<OfficeListItemDto>;
}>> {
    const obs = officeControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerFindAll(params: OfficeControllerFindAll$Params, context?: HttpContext): Observable<PaginatedDto & {
'items'?: Array<OfficeListItemDto>;
}> {
    const resp = this.officeControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PaginatedDto & {
'items'?: Array<OfficeListItemDto>;
}>): PaginatedDto & {
'items'?: Array<OfficeListItemDto>;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerCreate()` */
  static readonly OfficeControllerCreatePath = '/api/office';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerCreate$Response(params: OfficeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<OfficeDto>> {
    const obs = officeControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerCreate(params: OfficeControllerCreate$Params, context?: HttpContext): Observable<OfficeDto> {
    const resp = this.officeControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OfficeDto>): OfficeDto => r.body)
    );
  }

  /** Path part for operation `officeControllerUpdate()` */
  static readonly OfficeControllerUpdatePath = '/api/office';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerUpdate$Response(params: OfficeControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<OfficeDto>> {
    const obs = officeControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerUpdate(params: OfficeControllerUpdate$Params, context?: HttpContext): Observable<OfficeDto> {
    const resp = this.officeControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OfficeDto>): OfficeDto => r.body)
    );
  }

  /** Path part for operation `officeControllerFindAllDropdown()` */
  static readonly OfficeControllerFindAllDropdownPath = '/api/office/dropdown';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerFindAllDropdown()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerFindAllDropdown$Response(params: OfficeControllerFindAllDropdown$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OfficeNameDto>>> {
    const obs = officeControllerFindAllDropdown(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerFindAllDropdown$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerFindAllDropdown(params: OfficeControllerFindAllDropdown$Params, context?: HttpContext): Observable<Array<OfficeNameDto>> {
    const resp = this.officeControllerFindAllDropdown$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<OfficeNameDto>>): Array<OfficeNameDto> => r.body)
    );
  }

  /** Path part for operation `officeControllerFindOne()` */
  static readonly OfficeControllerFindOnePath = '/api/office/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerFindOne$Response(params: OfficeControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<OfficeDto>> {
    const obs = officeControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerFindOne(params: OfficeControllerFindOne$Params, context?: HttpContext): Observable<OfficeDto> {
    const resp = this.officeControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OfficeDto>): OfficeDto => r.body)
    );
  }

  /** Path part for operation `officeControllerDelete()` */
  static readonly OfficeControllerDeletePath = '/api/office/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerDelete$Response(params: OfficeControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = officeControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerDelete(params: OfficeControllerDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.officeControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `officeControllerGetIncidentsList()` */
  static readonly OfficeControllerGetIncidentsListPath = '/api/office/{id}/incidents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerGetIncidentsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerGetIncidentsList$Response(params: OfficeControllerGetIncidentsList$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = officeControllerGetIncidentsList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerGetIncidentsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerGetIncidentsList(params: OfficeControllerGetIncidentsList$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.officeControllerGetIncidentsList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `officeControllerRestore()` */
  static readonly OfficeControllerRestorePath = '/api/office/restore/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerRestore()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerRestore$Response(params: OfficeControllerRestore$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = officeControllerRestore(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerRestore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerRestore(params: OfficeControllerRestore$Params, context?: HttpContext): Observable<void> {
    const resp = this.officeControllerRestore$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
